// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rg-6";
export var imgContainer = "_rg-3";
export var menuIcon = "_rg-5";
export var pillWrapper = "_rg-2";
export var pillsContainer = "_rg-1";
export var subscriptionCard = "_rg-0";
export var subscriptionLogo = "_rg-4";